import { useAxios } from "../../utils/hooks";

const useFrameTemplates = async () => {
  const { response } = await useAxios({
    url: "/qr/frames/summary/",
    method: "GET",
  });
  return { response };
};

export default useFrameTemplates;
